import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Domain } from './domain.service';
import { File } from './interface';
import { ReadTrackingPayload } from './read-tracking.service';

export interface Document {
  uuid: string;
  title: string;
  description: string;
  publication_date: string;
  url: string;
  files: Array<File>;
  consultations_count?: number;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(
    private httpClient: HttpClient
  ) { }

  list({ domain }: { domain?: Domain }) {
    // Source of truth currently uses /events in back-office.
    // Map event payloads to Document shape for the app.
    const url = `${environment.apiUrl}/events`;
    return this.httpClient.get<any[]>(url).pipe(
      map((events) => {
        const sortedEvents = (events || []).slice().sort((a, b) => {
          const aDate = a && a.event_date ? a.event_date : '';
          const bDate = b && b.event_date ? b.event_date : '';
          // event_date is in "YYYY-MM-DD HH:mm:ss" format, so string compare works
          return bDate.localeCompare(aDate);
        });

        return sortedEvents.map(
          (e) =>
            ({
              uuid: e.uuid,
              title: e.title,
              description: e.description,
              publication_date: e.event_date,
              url: e.url,
              files: e.files || [],
              consultations_count: Number(e.consultations_count) || 0,
            } as Document)
        );
      })
    );
  }

  one(uuid: string): Observable<Document> {
    return this.httpClient.get<Document>(`${environment.apiUrl}/documents/${uuid}`);
  }

  consult(uuid: string, fileUuid: string, payload: ReadTrackingPayload = {}) {
    return this.httpClient.post(`${environment.apiUrl}/events/${uuid}/consult`, {
      ...payload,
      file_uuid: fileUuid,
    });
  }
}
